import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from "../../service/auth.service";
import {ProReportStateService} from "../../service/pro-report-state-service";
import {ObligorSearchTable} from "../../obligor-search/obligor-search-table";

@Component({
  template: '',
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService,
              private router: Router,
              private proReportStateService: ProReportStateService,
              private obligorSearchTable: ObligorSearchTable) {
  }

  ngOnInit(): void {
    this.authService.logout()
      .subscribe(res => {
        this.proReportStateService.clear();
        this.obligorSearchTable.clear();
        this.router.navigateByUrl('/login');
      });
  }

}
